import type { ComponentPropsWithoutRef } from 'react'
import { useCloudinaryAccessUrl } from '../cloudinary-access-token'
import { useImageFallback } from './use-image-fallback'

export type ImageProps = Omit<ComponentPropsWithoutRef<'img'>, 'src' | 'alt'> & {
  src: string
  alt: string
}

export const Image = ({ src, alt, onError, srcSet, ...props }: ImageProps) => {
  const accessUrl = useCloudinaryAccessUrl()
  const { imageSrc, isFallback, onError: showFallback } = useImageFallback(accessUrl(src))

  return (
    <img
      {...props}
      src={imageSrc}
      srcSet={isFallback ? undefined : srcSet}
      alt={alt}
      onError={event => {
        showFallback()
        onError?.(event)
      }}
    />
  )
}
